
export class CartSummary {
    totalQuantity: number;
    totalPrice: number;
    branchName: string;
    totalDiscount: number;
    TotalNet:number;
    couponValue:number = 0;
    IsPromoCode:boolean = false;
}